import {
	DB_INITIALIZE,
	DB_UPDATE,
	ChatActionTypes,
} from './types'

import { initialState } from './reducers'

export function dbInitialize():ChatActionTypes {
  let data=localStorage.getItem("db")
	let state=initialState
  try {
    state=JSON.parse(data || "")
  } catch(err) {
  }

  return({
		type:DB_INITIALIZE,
    state,
  })
}

export function dbUpdate(payload: any):ChatActionTypes {
	return {
		type:DB_UPDATE,
    payload: payload,
  }

}
